import { Construction } from 'lucide-react';
import clsx from 'clsx';

interface DevelopmentNoticeProps {
  /** Extra classes for spacing within the host surface. */
  className?: string;
  /** Tighter padding/type for cramped surfaces like the chatbot panel. */
  compact?: boolean;
}

/**
 * Amber notice shown on every experimental ("Version 2") surface so users
 * understand the feature is a preview and not yet released. Copy is kept
 * identical everywhere it appears.
 */
export default function DevelopmentNotice({ className, compact = false }: DevelopmentNoticeProps) {
  return (
    <div
      role="status"
      className={clsx(
        'flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 text-amber-800',
        compact ? 'px-3 py-2.5' : 'px-4 py-3',
        className,
      )}
    >
      <Construction
        className={clsx('flex-shrink-0 text-amber-600', compact ? 'mt-0.5 h-4 w-4' : 'mt-0.5 h-5 w-5')}
        aria-hidden="true"
      />
      <div className={compact ? 'text-xs' : 'text-sm'}>
        <p className="font-semibold">This feature is under development.</p>
        <p className="text-amber-700">It will be released in Version 2.</p>
      </div>
    </div>
  );
}
